import React from 'react';
interface DogoLogoProps {
  size?: number;
  className?: string;
}
export function DogoLogo({
  size = 42,
  className = ''
}: DogoLogoProps) {
  return <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" data-id="element-115">
      <polygon points="40,4 76,72 4,72" fill="none" stroke="#e00000" strokeWidth="4" data-id="element-116" />
      <polygon points="40,17 64,65 16,65" fill="none" stroke="#c00000" strokeWidth="2.5" data-id="element-117" />
      <polygon points="40,30 52,58 28,58" fill="none" stroke="#a00000" strokeWidth="2" data-id="element-118" />
      <line x1="40" y1="30" x2="40" y2="65" stroke="#e00000" strokeWidth="2" data-id="element-119" />
    </svg>;
}